<div class="panel panel-fill">
    <div class="panel-body home-panel-body">

        <div class="home-header text-center mb-5">
            <h1 class="mb-2 mt-3">SeagrassTools</h1>
            <p class="mb-5">Integrated tools for monitoring, restoring, and understanding seagrass ecosystems</p>
            <div class="row g-4 align-items-stretch">

                @for (widget of widgets; track widget)
                {
                <div class="col-sm-3 d-flex">
                    <div class="tools-widget">
                        <div class="widget-header">
                            <img src="{{widget.logoUrl}}" alt="{{widget.title}} logo">
                            <p>{{widget.title}}</p>
                        </div>
                        <div class="widget-body text-center">
                            <p>{{widget.description}}</p>
                            <div>
                                <a href="{{widget.url}}" target="_blank" class="btn btn-primary">Explore</a>
                            </div>

                        </div>
                    </div>

                </div>
                }


            </div>
        </div>




        <div class="row bottom-section">

            <div class="col-sm-6 left-column">
                <p>SeagrassTools brings together four complementary platforms — <b>SeagrassSpotter</b>, <b>SeagrassRestorer</b>, <b>SeagrassViewer</b>, and <b>SeagrassTracker</b> — into a single unified suite for seagrass science, conservation, and management.</p>

                <p>By integrating citizen science, ecological data, restoration experiments, and spatial analytics, SeagrassTools enables users to collect, download, analyse, and act on seagrass data more effectively than ever before.</p>

                <p>From local restoration projects to global monitoring efforts, SeagrassTools supports evidence-based decision-making across the full conservation cycle.</p>

                <div class="learn-more-button-container">
                    <a routerLink="/info" class="btn btn-lg btn-primary learn-more-button">Learn More</a>
                </div>

            </div>



            <div class="col-sm-6 right-column">
                <h2>A connected approach to seagrass conservation</h2>
                <p>Seagrass ecosystems are among the most valuable yet threatened marine habitats globally. Effective seagrass conservation requires coordinated data collection, standardised metrics, and accessible tools that bridge science, practice, and community engagement.</p>

                <h3>SeagrassTools provides:</h3>
                <ul>
                    <li>Standardised data to ensure consistency across projects and regions</li>
                    <li>Data that links ecological condition, threats, and restoration outcomes</li>
                    <li>Scalable tools suitable for local initiatives through to global programmes</li>
                    <li>Accessible platforms designed for scientists, practitioners, and citizen scientists alike</li>
                </ul>

                <h3>What you can do with SeagrassTools:</h3>
                <ul>
                    <li>Monitor seagrass distribution and condition using citizen science and field data</li>
                    <li>Quantify key indicators such as percentage cover</li>
                    <li>Plan and evaluate restoration interventions globally</li>
                    <li>Visualise spatial and temporal patterns in seagrass ecosystems</li>
                    <li>Track change to support adaptive management and policy decisions</li>
                </ul>

                <h3>One ecosystem.</h3>
                <ul>
                    <li><b>SeagrassSpotter</b> - Collect and validate seagrass observations globally</li>
                    <li><b>SeagrassViewer</b> - Explore and visualise seagrass data</li>
                    <li><b>SeagrassRestorer</b> - Design and assess restoration strategies</li>
                    <li><b>SeagrassTracker</b> - Monitor change and evaluate conservation outcomes</li>
                </ul>

                <h3>Driving impact through integration</h3>
                <p>SeagrassTools is built to strengthen the link between data and decision-making. By unifying tools across the conservation pipeline, it reduces barriers to analysis, improves data interoperability, and enhances the ability to scale impact.</p>
            </div>

        </div>





    </div>

</div>